import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import MainFeaturedPost from "./MainFeaturedPost";
import FeaturedProduct from "./FeaturedProduct";
import Main from "./Main";
//import Sidebar from './Sidebar';
import Header from "./Header";
import Footer from "./Footer";
import post1 from "./blog-post.1.md";
import post2 from "./blog-post.2.md";
import post3 from "./blog-post.3.md";
import { useAuth } from "./AuthContext";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Box, Button, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { restUrlProducts } from "./common";
import TextField from "@mui/material/TextField";
import { getSections } from "./common";

const mainFeaturedPosts = [
  {
    title: "",
    description: "",
    image: "/images/4201c19d8949d15cc8c6.jpg",
    imageText: "",
    linkText: "",
  },
  {
    title: "",
    description: "",
    image: "/images/4805a9f4907ea4544135.jpg",
    imageText: "",
    linkText: "",
  },
  {
    title: "",
    description: "",
    image: "/images/323168d630012a54cb38.jpg",
    imageText: "",
    linkText: "",
  },
  {
    title: "",
    description: "",
    image: "/images/403128899e82118a78de.jpg",
    imageText: "",
    linkText: "",
  },
];

// const featuredPosts = [
//   {
//     title: "Featured post",
//     date: "Nov 12",
//     description:
//       "This is a wider card with supporting text below as a natural lead-in to additional content.",
//     image: "https://source.unsplash.com/random?wallpapers",
//     imageLabel: "Image Text",
//   },
//   {
//     title: "Post title",
//     date: "Nov 11",
//     description:
//       "This is a wider card with supporting text below as a natural lead-in to additional content.",
//     image: "https://source.unsplash.com/random?wallpapers",
//     imageLabel: "Image Text",
//   },
// ];

const posts = [post1, post2, post3];

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export async function deletePostById(id) {
  try {
    console.log(restUrlProducts);
    const response = await axios.delete(`${restUrlProducts}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Delete error:", error);
    throw error;
  }
}

export default function Products() {
  const handleDelete = async (id) => {
    if (window.confirm(t("deletePrompt"))) {
      try {
        await deletePostById(id);
        alert(t("productDeleted"));
        setFeaturedProducts((prev) =>
          prev.filter((product) => product.id !== id)
        );
        // optionally refresh or filter posts in UI
      } catch (err) {
        alert(t("failedToDeleteProduct"));
      }
    }
  };

  const handlePageChange = (event, value) => {
    setMeta((prev) => ({ ...prev, page: value }));
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setMeta((prev) => ({ ...prev, page: 1 }));
    console.log("Search text:", e.target.value);
  };

  const [searchText, setSearchText] = useState("");
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [meta, setMeta] = useState({
    page: 1,
    limit: 4,
    total: 0,
    total_pages: 1,
  });
  const fetchData = async () => {
    try {
      const res = await axios.get(`${restUrlProducts}`, {
        params: {
          search: searchText || undefined,
          page: meta.page,
          limit: meta.limit,
        },
      });
      setFeaturedProducts(res.data.data);
      setMeta((prev) => ({
        ...prev,
        total: res.data.meta.total,
        total_pages: res.data.meta.total_pages,
      }));
    } catch (err) {
      console.error("Failed to fetch products", err);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchData();
    }, 400); // Delay in ms

    return () => clearTimeout(delayDebounce);
  }, [searchText, meta.page, meta.limit]);

  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <ThemeProvider theme={defaultTheme}>
      <Helmet>
        <title>{t("title")}</title> {/* 👈 Dynamic browser title */}
      </Helmet>
      <CssBaseline />
      <Container maxWidth="lg">
        {/* <Header title="广州群科国际贸易有限公司" sections={sections} /> */}
        <Header title={t("title")} sections={getSections(t)} />
        <main>
          <MainFeaturedPost posts={mainFeaturedPosts} />
          <Box sx={{ mt: 3, mb: 2 }}>
            <TextField
              fullWidth
              label={t("searchProducts")}
              variant="outlined"
              value={searchText}
              onChange={handleSearchChange}
            />
          </Box>

          <Grid container spacing={4}>
            {featuredProducts.map((prd) => (
              <Grid item xs={12} md={6} key={prd.title}>
                <FeaturedProduct product={prd} />
                {isAuthenticated && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => navigate(`/product/${prd.id}`)}
                    >
                      {t("edit")}
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(prd.id)}
                    >
                      {t("delete")}
                    </Button>
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>
          {isAuthenticated && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                mb: 2,
                mt: 3,
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={() => navigate("/product")}
              >
                {t("addProduct")}
              </Button>
            </Box>
          )}
          {meta.total_pages > 1 && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
              <Pagination
                count={meta.total_pages}
                page={meta.page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
          {/* <Grid container spacing={5} sx={{ mt: 3 }}>
            <Main title="From the firehose" posts={posts} />
          </Grid> */}
        </main>
      </Container>
      {/* <Footer
        title="电话：020-81605975 传真：020-81623677"
        description="地址：广州市荔湾区花地大道中83号金昊大厦12楼 邮编：510375"
      /> */}
      <Footer title={t("footerTitle")} description={t("footerDesc")} />
    </ThemeProvider>
  );
}
